import React from 'react';
import { AiChatDialog } from './AiChatDialog';
import { useAiDocumentChat } from './AiDocumentChatContext';

/** Renders the single maximized AI chat dialog, if any - MUI's Dialog portals itself, so this
 * can be mounted anywhere; AiChatMinimizedBar (rendered separately, inside <main>) is the one
 * that needs a specific position in the layout. */
export const AiChatDialogRoot: React.FC = () => {
    const { sessions, activeSessionKey } = useAiDocumentChat();
    const activeSession = sessions.find(session => session.key === activeSessionKey && !session.isMinimized);

    if (!activeSession) {
        return null;
    }

    return <AiChatDialog session={activeSession} />;
};
